import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/features/auth/authStore';
import { landingPath } from '@/features/dashboard/config';

/**
 * Public layout — renders child routes without auth.
 * If already signed in, redirects to the first report of the user's switcher.
 */
export function PublicLayout() {
  const auth = useAuth();
  if (auth?.token) {
    return <Navigate to={landingPath(auth.allowedReports, auth.role === 'admin')} replace />;
  }
  return <Outlet />;
}
